var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M10.571 5.536A1 1 0 1 1 9.157 6.95a1 1 0 0 1 1.414-1.414zm-3.535 7.778a1 1 0 0 0 1.414 0l4.364-4.364a1 1 0 0 0 .293-.707V4a1 1 0 0 0-1-1H7.864a1 1 0 0 0-.707.293L2.793 7.657a1 1 0 0 0 0 1.414l4.243 4.243zm-.708.707L2.086 9.778a2 2 0 0 1 0-2.828L6.45 2.586A2 2 0 0 1 7.864 2h4.243a2 2 0 0 1 2 2v4.243a2 2 0 0 1-.586 1.414L9.157 14.02a2 2 0 0 1-2.829 0z" })
  );
});